module.exports = __webpack_public_path__ + "static/img/scene3.363939e8.jpg";